module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-panel', {
    attrs: {
      "contextual-style": "primary"
    }
  }, [_c('h1', {
    staticClass: "panel-title",
    slot: "heading"
  }, [_vm._v("\n      Profile Reset\n    ")]), _vm._v(" "), _c('div', {
    slot: "body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.doNothing()
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "disabled": "",
      "type": "button",
      "aria-label": "Help"
    }
  }, [_vm._v("Profile name")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formdata.profileid),
      expression: "formdata.profileid"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.doingSomething,
      "autofocus": "",
      "aria-label": "Profile name",
      "placeholder": "eg: 64219991234 or bobjones"
    },
    domProps: {
      "value": (_vm.formdata.profileid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formdata.profileid = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _c('div', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('span', {
    staticClass: "error",
    staticStyle: {
      "color": "#ff3333"
    }
  }, [_vm._v(" " + _vm._s(_vm.errmsg) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "disabled": _vm.doingSomething,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.resetPIN(_vm.formdata)
      }
    }
  }, [_vm._v("PIN Reset")])]), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "disabled": _vm.doingSomething,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.resetProfile(_vm.formdata)
      }
    }
  }, [_vm._v("Profile Reset/Delete")])])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67f957ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/profiles/reset/index.vue
// module id = 227
// module chunks = 1